import { TicketPriority } from '../../shared/models/ticket.model';
import { TicketUiModel } from '../../shared/ui-models/ticket.ui-model';

// Same chip as the leads screens. Copied, not imported: modules don't import each other.
export const CHIP =
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-gilroy-medium';

/**
 * Coral for P1 only: it is the "drop what you are doing" colour across the admin,
 * and spending it on P2 would teach people to ignore it.
 */
export const PRIORITY_STYLE: Record<TicketPriority, string> = {
  P1: 'bg-secondary-100 text-secondary-800',
  P2: 'bg-creams-600 text-creams-900',
  P3: 'bg-blue text-neutral-500',
  P4: 'bg-neutral-50 text-neutral-400'
};

export const PRIORITY_LABEL: Record<TicketPriority, string> = {
  P1: 'P1 Critical',
  P2: 'P2 Urgent',
  P3: 'P3 Standard',
  P4: 'P4 Low'
};

export const stateStyle = (ticket: TicketUiModel): string =>
  ticket.isClosed
    ? 'bg-neutral-50 text-neutral-300'
    : ticket.state === 'new'
    ? 'bg-primary-50 text-primary-700'
    : 'bg-creams-500 text-creams-900';

export const titleCase = (value: string): string =>
  (value || '').replace(/_/g, ' ').replace(/^./, (c: string) => c.toUpperCase());
